// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import { observable } from 'mobx';

export class ModalStore {
    @observable headline?: string;
    @observable content?: any;

    createModal(headline: string, content: any) {
        this.headline = headline;
        this.content = content;
    }

    removeModal() {
        this.headline = '';
        this.content = null;
    }
}

export default new ModalStore();